import React, { FunctionComponent, useState, useEffect } from 'react';
import Input from 'ui/atoms/input';
import Section from 'ui/atoms/section';
import Translate from 'ui/atoms/translate';
import Header from 'ui/atoms/header';
import { VoucherFields } from 'apps/issuer/pages/vouchers/create-voucher';

interface VoucherUsesByInvestorProps {
  Form: any;
  values: VoucherFields;
  numberOfUsesByInvestorAmount: number | undefined;
  onChangeUsesByInvestor: (noOfUses: string, amount: number) => void;
}

export enum VoucherUsesByInvestorEnum {
  UNLIMITED = 'unlimited',
  FIRST_TIME = 'firstTime',
  LIMITED_TO = 'limitedTo',
}

const VoucherUsesByInvestor: FunctionComponent<VoucherUsesByInvestorProps> = ({
  Form,
  values,
  numberOfUsesByInvestorAmount,
  onChangeUsesByInvestor,
}) => {
  const [amount, setAmount] = useState(numberOfUsesByInvestorAmount || 1);

  useEffect(() => {
    onChangeUsesByInvestor(values.numberOfUsesByInvestor, amount);
  }, [values.numberOfUsesByInvestor, amount]);

  return (
    <Section>
      <Form.Group name="numberOfUsesByInvestor" required={true}>
        <Header spacing="medium">
          <Translate name="createVoucherForm.numberOfUsesByInvestor.label" />
        </Header>
        <Section spacing="small">
          <Form.GroupToggle compact>
            {Object.values(VoucherUsesByInvestorEnum).map((option) => (
              <Form.Radio value={option} key={option}>
                <Translate name={`createVoucherForm.${option}`} />
              </Form.Radio>
            ))}
          </Form.GroupToggle>
        </Section>
        <Input
          type="number"
          min={1}
          label={<Translate name={'createVoucherForm.amount'} />}
          disabled={values.numberOfUsesByInvestor !== VoucherUsesByInvestorEnum.LIMITED_TO}
          onChange={(e: any) => setAmount(e.target.value)}
          value={values.numberOfUsesByInvestor === VoucherUsesByInvestorEnum.LIMITED_TO ? amount.toString() : ''}
        />
        <small>
          <Translate name={`createVoucherForm.numberOfUsesByInvestor.info`} />
        </small>
      </Form.Group>
    </Section>
  );
};

export default VoucherUsesByInvestor;
